import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant, UrlUtil, LoaderService, CfetPageNamesConstant } from '../cfet-core';

@Component({
    selector: 'app-cfet-landing',
    templateUrl: './cfet-landing.component.html',
    styleUrls: ['./cfet-landing.component.scss'],
    standalone: false
})
export class CfetLandingComponent extends CfetBaseComponent implements OnInit {
  public affCodeForm: UntypedFormGroup;
  affCode: UntypedFormControl;
  public openBadCodePopUp = '';
  public showBadCodePopUp = false;
  isSpaOrg: boolean;
  enableAffiliation: boolean = false;
  copyAffiliationCode: any;
  isInvalidCode: boolean;
  organisationDetails: any = {};
  showLoadingComp = false;

  constructor(private cfetService: CfetService,
    private routerSer: Router,
    private activatedrouteSer: ActivatedRoute,
    private loaderService: LoaderService,
    private urlUtilSer: UrlUtil,
    private formBuilderModule: UntypedFormBuilder,
    private titleProperty: Title) {
    super();
  }

  ngOnInit() {
    
    this.titleProperty.setTitle(this.cfetTitles.landing.htmlTitle);
    if (sessionStorage.getItem('orgInformation') && Object.keys(sessionStorage.getItem('orgInformation')).length !== 0) {
      sessionStorage.removeItem('orgInformation');
    }
    if (sessionStorage.getItem('organisationDetailsInfo') && Object.keys(sessionStorage.getItem('organisationDetailsInfo')).length !== 0) {
      sessionStorage.removeItem('organisationDetailsInfo');
    }
    sessionStorage.clear();
    this.affCode = new UntypedFormControl('',);
    this.affCodeForm = this.formBuilderModule.group({
      affCode: this.affCode
    });
    this.cfetService.isLandingPage.next(true);
    this.activatedrouteSer.queryParamMap
      .subscribe(params => {
        this.affCode.setValue(params.get('affiliationcode'));
        const event = { type: 'click' };
        if (this.affCode.value) {
          this.onSubmitAffCode(event);
        }
      }
      );
  }

  get f() { return this.affCodeForm.controls; }

  eligibility() {
    this.redirecturl(this.cfetNavLinks.utf_header_links.check_eligibility_link);
  }

  affiliationenable() {
    this.enableAffiliation = true;
  }

  redirecturl(url) {
    window.location.href = url;
  }

  onSubmitAffCode(event) {
    if ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) &&
      (this.affCode.value !== '' && this.affCode.value !== null && this.affCode.value.length > 0)) {
      this.showLoadingComp = true;
      const param = { retcode: this.affCode.value };
      const url = `${this.urlUtilSer.formatURlParams(CFETILMEndpointsConstant.GET_AFFILIATION_CODE, param)}`;
      this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
        this.setOrgDetails(data);
      }, (_error) => {
        this.showLoadingComp = false;
        this.copyAffiliationCode = this.affCode.value;
        this.isInvalidCode = true;
        this.openBadCodePopUp = 'open';
        this.showBadCodePopUp = true;
      });
      // Override the loaderOverlay background-color from styles.scss
      setTimeout(function () {
        if (document.getElementById('loaderOverlay')) {
          document.getElementById('loaderOverlay').style.cssText = 'background-color: #000000 !important';
        }
      }, 100);
    }
  }

  setOrgDetails(data) {
    if (data && data.profile) {
      data.profile.forEach(val => {
        this.isSpaOrg = (val.attribute_name === 'isSpaOrg' && val.attribute_value === 'TRUE') ? true : false;
      });
      this.organisationDetails.orgProfileInfo = data;
      this.organisationDetails.orgid = data.orgid;
      this.organisationDetails.orgName = data.orgName;
      this.organisationDetails.isSpaOrg = this.isSpaOrg;
      this.organisationDetails.affCode = this.affCode.value.replace(/ /g, '');
      sessionStorage.setItem('orgInformation', JSON.stringify(this.organisationDetails));
      this.showLoadingComp = false;
      this.isSpaOrg ? this.routerSer.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY]) :
        this.routerSer.navigate([CfetPageNamesConstant.AFFILIATION_CODE]);
    }
  }

  closeBadCodeModal(event) {
    if (event === 'modalClose') {
      this.openBadCodePopUp = 'close';
      this.showBadCodePopUp = false;
    }
  }
}
